import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';

import useStyles from './styles';

const Error = ({message, isOpen, onClose}) => {

  const classes = useStyles();

  return <Dialog
    open={isOpen}
    onClose={onClose}
    fullWidth
    scroll='body'
  >
    <Grid
      container
      justify='space-around'
      className={classes.error}
    >
      <Grid item xs={12}>
        <Typography className={classes.text}>
          {message}
        </Typography>
      </Grid>
      <Grid item>
      </Grid>
      <Grid item>
        <Button color='secondary' onClick={onClose}>
          Fechar
        </Button>
      </Grid>
    </Grid>
  </Dialog>;
}

export default Error;
